export { default as BitacoraGrid } from './Listar';
export { default as BitacoraDetalle } from './Detalle';
